import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const PaymentFailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const errorMsg = searchParams.get('errMsg');
  const loginType = searchParams.get('loginType');
  const token = searchParams.get('token');

  return (
    <Box>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        交易錯誤
      </Typography>
      {errorMsg ? (
        <Box>
          <Typography
            variant='h6'
            sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        </Box>
      ) : null}
      <Box mt={6}>
        <Button
          variant='contained'
          color='info'
          sx={{ width: 168 }}
          onClick={() => {
            if (loginType === 'token' && token) {
              navigate(`/?t=${token}`);
              return;
            }
            navigate('/login');
          }}>
          請重新操作
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentFailPage;
